module.exports = __webpack_public_path__ + "static/img/classroom_3.a416671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/classroom_3.jpg
// module id = JXX0
// module chunks = 3